class ProductService
  constructor: ($http, ConfigService, $filter, $rootScope, $q) ->
    @$http          = $http
    @ConfigService  = ConfigService
    @$filter        = $filter
    @$rootScope     = $rootScope
    @$q             = $q
    @data           = {}
    @fetchedGetData = false

  isLoan: ->
    @data and @data.product_type is "installment"

  isCreditLine: ->
    @data and @data.product_type is "credit_line"

  isPointOfSale: ->
    !!(@data?.product_type == "point_of_sale")

  getBorrowAmount: (src = @data) ->
    if @isLoan()
      (src.amount_cents / 100)
    else if @isCreditLine()
      (src.credit_limit_cents / 100)

  firstDrawAmount: (src = @data) ->
    if @isCreditLine()
      (src.first_draw_amount_cents / 100)

  periodFee: (src = @data) ->
    if @isCreditLine()
      (src.period_fee_cents / 100)

  drawFeeAmount: (src = @data) ->
    if @isCreditLine()
      (src.draw_fee_percentage * (@data.first_draw_amount_cents / 100))

  monthlyDrawFeeAmount: (src = @data) ->
    if @isCreditLine()
      ((src.draw_fee_percentage * (src.first_draw_amount_cents / 100)) / 24)

  creditLimit: (src = @data) ->
    if @isCreditLine()
      (src.credit_limit_cents / 100)

  getBorrowApr: (src = @data) ->
    src.apr

  getBorrowInterestRate: (src = @data) ->
    src.interest_rate

  isApproved: (src = @data) ->
    src.approved

  redirectUrl: (src = @data) ->
    src.redirect_url

  roundToNearestCent: (amount) ->
    (Math.round(amount + "e+2")  + "e-2") / 1

  refreshData: (data, broadcast) ->
    # refactor these into filters
    angular.extend(@data, data)
    # Custom Loan Initiator
    @data.borrow_amount = @getBorrowAmount()
    if @data.loans?
      for loan, index in @data.loans
        loan.borrow_amount = @getBorrowAmount(loan)
        loan.borrow_apr = @getBorrowApr(loan)
      @data.term ||= @data.term_int
      @data.monthly_payment ||= parseFloat @data.monthly_payment_display
    @data.borrow_apr = @getBorrowApr()
    @data.interest_rate = @getBorrowInterestRate()
    @data.first_draw_amount = @firstDrawAmount()
    @data.period_fee = @periodFee()
    @data.draw_fee_amount = @drawFeeAmount()
    @data.monthly_draw_fee_amount = @monthlyDrawFeeAmount()
    @data.credit_limit = @creditLimit()
    @data.approved = @isApproved()
    @data.redirect_url = @redirectUrl()
    if broadcast?
      @$rootScope.$broadcast('product:data', @data)
    @data

  filteredData: (data) ->
    if data and @isLoan()
      @data.term = String(data.term)
      if _.isArray(data.available_terms) && data.available_terms.length > 0
        @data.available_terms = @$filter('OptionValueToString')(data.available_terms, 'months')
        @data.monthly_payment = _.findWhere(@data.available_terms, months: @data.term)?.monthly_payment
        @data.monthly_payment ||= parseFloat @data.monthly_payment_display
    @$rootScope.$broadcast('product:data', @data)
    @data

  updateParams: ->
    data =
      borrow_amount: @data.borrow_amount
    if @isCreditLine()
      data.first_draw_amount = @data.first_draw_amount
    else
      data.term = @data.term
    data

  update: (customer_application_id, additional_params) ->
    params = @updateParams()
    angular.extend(params, additional_params)
    deferred = @$q.defer()
    @sendDetails(customer_application_id, params).then (response) =>
      deferred.resolve(@filteredData(@refreshData(response.data)))
    deferred.promise

  getSpecificLoanForCustomer: (customer_application_id, amount) ->
    @$rootScope.$broadcast('product:custom_updating', true)
    deferred = @$q.defer()
    @$http(
      method: "POST"
      url: "/api/customer_applications/#{customer_application_id}/pull_loan_option"
      data:
        amount: amount
      ignoreLoadingBar: true
    ).then((response) ->
      { data } = response
      deferred.resolve(data)
      response
    ).finally => @$rootScope.$broadcast('product:custom_updating', false)
    deferred.promise

  silentUpdate: (customer_application_id, additional_params) ->
    params = @updateParams()
    angular.extend(params, additional_params)
    deferred = @$q.defer()
    @sendDetails(customer_application_id, params).then (response) =>
      angular.extend(@data, response.data)
      deferred.resolve()
    deferred.promise

  getDetails: (customer_application_id) ->
    @$rootScope.$broadcast('product:updating', true)
    promise = @$http(
      method: "GET"
      url: "#{@ConfigService.apiBaseUrl(customer_application_id)}/product_details"
      ignoreLoadingBar: true
    ).then((response) =>
      { data } = response
      @filteredData(@refreshData(data))
      @fetchedGetData = true
      response
    ).finally =>
      @$rootScope.$broadcast('product:updating', false)
    promise

  getCachedDetails: (customer_application_id) ->
    deferred = @$q.defer()
    if @fetchedGetData
      deferred.resolve(true)
    else
      @getDetails(customer_application_id).then (response) =>
        @getPaymentSchedule(response.data?.id)
        # let's resolve before getting the payment schedule
        # bc we don't care about that for this promise (only need product data)
        deferred.resolve(true)
    deferred.promise

  hasCompleteDetails: ->
    _.isObject(@data) and !_.isEmpty(@data) and _.isObject(@data.available_terms) and !_.isEmpty(@data.available_terms)

  sendDetails: (customer_application_id, data) ->
    @$rootScope.$broadcast('product:updating', true)
    promise = @$http(
      method: "POST"
      data: data
      url: "#{@ConfigService.apiBaseUrl(customer_application_id)}/send_product_details"
    )
    .finally( => @$rootScope.$broadcast('product:updating', false))

    promise

  getPaymentSchedule: (loan_id) ->
    if loan_id?
      @$http(
        method: "GET"
        url: "/api/loans/#{loan_id}/payment_schedule"
      )
      .then((response) =>
        { data } = response
        parsed_data = _.map(data, (p) -> _.extend(p, { parsed_date: new Date(p.date).getTime() }))
        @$rootScope.$broadcast('product:payment_schedule:data', parsed_data)
        response
      )

  shouldDisableDashboardWorkflows: (loan) ->
    !!loan.cx_dash_payoff_info?.payoff_info || loan.should_disable_dash_workflows

  shouldUseNewQuotePayoffWorkflow: (loan) ->
    !!loan.cx_dash_payoff_info?.new_workflow_enabled

angular
.module("avant.products.services")
.service("ProductService", [
  "$http",
  "ConfigService",
  "$filter",
  "$rootScope",
  "$q",
  ProductService
])

if typeof exports != 'undefined'
  if typeof module != 'undefined' && module.exports
    exports = module.exports = ProductService
  exports.ProductService = ProductService
else
  window.ProductService = ProductService
